import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MembershipSection = ({ membership, onUpgrade, onManageBilling }) => {
  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg">
          <Icon name="CreditCard" size={24} color="var(--color-success)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Membership Details
          </h2>
          <p className="text-sm text-muted-foreground caption">
            Manage your subscription
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 p-4 md:p-6 bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg border border-border">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
                {membership?.planName}
              </h3>
              <div className="px-3 py-1 bg-success text-success-foreground rounded-full">
                <span className="text-xs font-medium caption">Active</span>
              </div>
            </div>
            <p className="text-2xl md:text-3xl font-heading font-bold text-primary data-text">
              ${membership?.price}/month
            </p>
            <p className="text-sm text-muted-foreground mt-1 caption">
              Next billing date: {membership?.nextBillingDate}
            </p>
          </div>
          <Button
            variant="default"
            size="default"
            iconName="ArrowUpCircle"
            iconPosition="left"
            onClick={onUpgrade}
          >
            Upgrade Plan
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Calendar" size={20} color="var(--color-primary)" />
              <h4 className="font-medium text-foreground">Member Since</h4>
            </div>
            <p className="text-lg font-semibold text-foreground data-text">
              {membership?.memberSince}
            </p>
          </div>

          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Clock" size={20} color="var(--color-primary)" />
              <h4 className="font-medium text-foreground">Auto-Renewal</h4>
            </div>
            <p className="text-lg font-semibold text-foreground">
              {membership?.autoRenewal ? 'Enabled' : 'Disabled'}
            </p>
          </div>
        </div>

        <div>
          <h4 className="font-medium text-foreground mb-3">Plan Benefits</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {membership?.benefits?.map((benefit, index) => (
              <div key={index} className="flex items-start gap-2">
                <Icon name="CheckCircle" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                <span className="text-sm text-foreground">{benefit}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-6 border-t border-border">
          <h4 className="font-medium text-foreground mb-3">Payment Method</h4>
          <div className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 bg-card rounded-lg">
                <Icon name="CreditCard" size={24} color="var(--color-primary)" />
              </div>
              <div>
                <p className="font-medium text-foreground">
                  •••• •••• •••• {membership?.paymentMethod?.last4}
                </p>
                <p className="text-sm text-muted-foreground caption">
                  Expires {membership?.paymentMethod?.expiry}
                </p>
              </div>
            </div>
            <Button
              variant="outline"
              size="default"
              onClick={onManageBilling}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipSection;